import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import styled from 'styled-components';

// material-ui icons
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import AddToPhotosIcon from '@mui/icons-material/AddToPhotos';
import NoPhotographyIcon from '@mui/icons-material/NoPhotography';
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';


// IMPORT FUNCTIONS
import getUrl from  "../../utils/functions/getUrl";
import PostDataComplex from '../../services/PostDataComplex';
import PostData from '../../services/PostData';
import removeImageFromAlbum from '../../utils/functions/removeImageFromAlbum';

// IMPORT COMPONENTS
import Album from './components/Album/Album';
import PictureContainer from './components/PictureContainer/PictureContainer';
import Modal from './components/Modal/Modal';
import MessageModal from '../../utils/components/Modals/MessageModal/MessageModal';
import DeleteAlbumModal from '../../utils/components/Modals/DeleteAlbumModal/DeleteAlbumModal';
import RemoveImageFromAlbumModal from '../../utils/components/Modals/RemoveImageFromAlbumModal/RemoveImageFromAlbumModal';
import DeleteImageModal from '../../utils/components/Modals/DeleteImageModal/DeleteImageModal'

// IMPORT DATA FOR LOCAL USE
import albumsData from './albumsData';
import imageAlbumAssoc from './imageAlbumAssoc';
// import imagesassoc from './components/Album/imagesassocData';



const Dashboard = (
  {
    logged, 
    toggleModal, setToggleModal, 
    handleImageModalExpand, 
    showDeletedImages, setShowDeletedImages,
    inAlbumOnly
  }
) => {

  const BASE_URL = getUrl();
  // console.log(`BASE_URL: ${BASE_URL}`);

  let history = useNavigate();


  const [ toggleDeleteImageModal, setToggleDeleteImageModal ] = useState(false)
  const [ deleteImageDataModal, setDeleteImageDataModal ] = useState({})
  const [ answerDeleteImageModal, setAnswerDeleteImageModal ] = useState(false)

  const [ toggleRemoveImageFromAlbumModal, setToggleRemoveImageFromAlbumModal ] = useState(false)
  const [removeImageFromAlbumDataModal, setRemoveImageFromAlbumDataModal] = useState(null);
  const [ answerRemoveImageFromAlbumModal , setAnswerRemoveImageFromAlbumModal ] = useState('')
  
  const [toggleDeleteAlbumModal, setToggleDeleteAlbumModal] = useState(false);
  const [deleteAlbumDataModal, setDeleteAlbumDataModal] = useState(null);
  const [toggleMessageModal, setToggleMessageModal] = useState(false);
  const [message, setMessage] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [messageTitle, setMessageTitle] = useState(null);

  const [albums, setAlbums] = useState(null);
  const [albumsToShow, setAlbumsToShow] = useState(null);
  
  
  // const [toggleModalImage, setToggleModalImage] = useState(false);
  
  const [assoc, setAssoc] = useState(null);
  
  const [associatedAlbumId, setAssociatedAlbumId] = useState(null);
  const [dessociatedAlbumId, setDessociatedAlbumId] = useState(0);
  const [imageAlbumUploaded, setImageAlbumUploaded] = useState(null);
  const [newAlbumCreated, setNewAlbumCreated] = useState(false);
  const [createAlbumMessage, setCreateAlbumMessage] = useState(null);
  const [albumDeleted, setAlbumDeleted] = useState(false);
  const [deleteAlbumResult, setDeleteAlbumResult] = useState(null);
  const [deleteAlbumMessage, setDeleteAlbumMessage] = useState(null);
  const [deleteAlbumMessageError, setDeleteAlbumMessageError] = useState(null);

  const [imageDirectory] = useState('https://rndwss.com/Pics/imgs');
  const [imgs] = useState(BASE_URL + '/uploaded/imgs/');



  
  // 
  // USE EFFECT(s)
  // 
  useEffect(()=>{
    console.log(`logged: ${logged}`)
    if(logged === false) {
      history(BASE_URL +"/");
    }
  },[logged]);
  
  
  useEffect(()=>{
    console.log(`inAlbumOnly: ${inAlbumOnly}`)
    
  },[inAlbumOnly]);
  
  // 
  // 
  // 

  // 
  // 
  // 

  // 
  // get all images in album associated with current user
  // 
  useEffect(()=>{

    albums && albums.length>0 && handleGetAlbumsImages();

  },[albums, associatedAlbumId, dessociatedAlbumId]);

  // 
  // load albums data
  // 
  useEffect(()=>{
    handleGetAlbums();
    newAlbumCreated && setNewAlbumCreated(false);
    albumDeleted && setAlbumDeleted(false);
    if(toggleDeleteAlbumModal){
      setDeleteAlbumResult(null);
      setDeleteAlbumMessage(null);
      setDeleteAlbumMessageError(null);
    }
  },[newAlbumCreated, albumDeleted, toggleDeleteAlbumModal]);


  // 
  // HENDLERS
  // 

  // 
  // 
  // 
  const handleGetAlbumsImages = () => {
    console.log(`handleGetAlbumsImages()`);

    const user = (JSON.parse(sessionStorage.userData)).user.usr_name;
    console.log(`user: ${user}`);
    const token = (JSON.parse(sessionStorage.userData)).user.token;
    console.log(`token: ${token}`);

    const data = {
      user: user,
      token: token,
    }

    const localHost = String(window.location).split('/')[2].includes('localhost');
    const network = String(window.location).split('/')[2].includes('10.0.0.6');
    console.log(`localHost: ${localHost}`);
    console.log(`network: ${network}`);
    
    if( localHost || network) {
      console.log('LOCALE!!!')

      // const fakeResponse = imagesData
      if(imageAlbumAssoc) {
        console.log(imageAlbumAssoc);
        console.log('albums images uploaded succesfully!!!');
        
        const getAlbumImages = {imageAlbumAssoc: imageAlbumAssoc};

        setAssoc(getAlbumImages.imageAlbumAssoc); 

      } else {
        console.log('Images upload error!!!');
      }

    } else {

      PostDataComplex('albums_manager', 'POST', 'getAlbumsImages', data)
        .then((response) => {
          console.log('handleGetAlbumsImages response.data:->');
          console.log(response.data);

          const getAlbumsImages = response.data.feedBack.getAlbumsImages.getAlbumsImagesResult;

          if(getAlbumsImages.imagesassoc) {
            console.log('albums images uploaded succesfully!!!');
            
            setAssoc(getAlbumsImages.imagesassoc); 
            
            
          } else {
            console.log('error uploading album images !!!');
            console.log(getAlbumsImages.error);
            setAssoc([]); 
          }
        }
      )
    }
  }

  // 
  // 
  // 
  const handleGetAlbums = () => {
    console.log(`handleGetAlbums()`);

    const user = (JSON.parse(sessionStorage.userData)).user.usr_name;
    console.log(`user: ${user}`);
    const token = (JSON.parse(sessionStorage.userData)).user.token;
    console.log(`token: ${token}`);
    
    const userData = {
      user: user,
      token: token
    }

    const localHost = String(window.location).split('/')[2].includes('localhost');
    const network = String(window.location).split('/')[2].includes('10.0.0.6');
    console.log(`localHost: ${localHost}`);
    console.log(`network: ${network}`);
    
    if( localHost || network) {
      console.log('LOCALE!!!')

      // const fakeResponse = imagesData
      if(albumsData) {
        console.log(albumsData);
        console.log('Albums uploaded succesfully!!!');

        setAlbums([...albumsData].reverse());

      } else {
        console.log('Images upload error!!!');
      }

    } else {

      // PostData('POST', 'getAlbums', userData)
      PostDataComplex('albums_manager', 'POST', 'getAlbums', userData)
        .then((response) => {
          console.log('getAlbums response.data:->');
          console.log(response.data);

          const getAlbums = response.data.feedBack.getAlbums.takeAlbumsResult.albums;

          if(getAlbums) {
            console.log('albums uploaded succesfully!!!');

            for(let i=0; i<getAlbums.length; i++) {
              getAlbums[i].albumLength = 0; 
            }
            console.log('//////////////////////////////////');
            console.log('getAlbums:->');
            console.log(getAlbums);

            setAlbums([...getAlbums].reverse());
            
          } else {
            console.log('albums upload error!!!');
          }
        }
      )
    }
  }

  // 
  // 
  // 
  const handleCreateAlbum = (album_name) => {
    console.log(`handleCreateAlbum()`);

    const token = (JSON.parse(sessionStorage.userData)).user.token;
    console.log(`token: ${token}`);
    const user = (JSON.parse(sessionStorage.userData)).user.usr_name;
    console.log(`user: ${user}`);

    console.log(`albumName: ${album_name}`);

    const data = {
      user: user,
      token: token,
      album_name: album_name,
    }

    // PostData('POST', 'createAlbum', data)
    PostDataComplex('albums_manager', 'POST', 'createAlbum', data)
      .then((response) => {
        console.log('createAlbum response.data:->');
        console.log(response.data);

        const createAlbum = response.data.feedBack.createAlbum.createAlbumResult.albumsaved;
        const createAlbumError = response.data.feedBack.createAlbum.createAlbumResult.error

        if(createAlbum) {
          console.log('album created succesfully!!!');

          setNewAlbumCreated(true);
          
        } else {
          
          console.log('albums creation error!!!');
          console.log(createAlbumError);
          setToggleModal(true);
          setCreateAlbumMessage(createAlbumError);
        }
      }
    )
  }

  // 
  // 
  // 
  const handleDeleteAlbum = (album_id) => {
    console.log(`handleDeleteAlbum()`);

    const token = (JSON.parse(sessionStorage.userData)).user.token;
    console.log(`token: ${token}`);
    const user = (JSON.parse(sessionStorage.userData)).user.usr_name;
    console.log(`user: ${user}`);

    console.log(`albumName: ${album_id}`);

    const data = {
      user: user,
      token: token,
      album_id: album_id,
    }

    PostDataComplex('albums_manager', 'POST', 'deleteAlbum', data)
      .then((response) => {
        console.log('deleteAlbum response.data:->');
        console.log(response.data);

        const deleteAlbumResult = response.data.feedBack.deleteAlbumData.deleteAlbumResult;

        if(deleteAlbumResult.deleteAlbum) {
          console.log('album deleted succesfully!!!');

          setAlbumDeleted(true);
          setDeleteAlbumMessage(deleteAlbumResult.message);

          setDeleteAlbumResult('deleted');

        } else {
          
          console.log('albums deletion error!!!');
          console.log(deleteAlbumResult.error);
          setDeleteAlbumMessageError(deleteAlbumResult.error);
          setDeleteAlbumResult('error');
        }
      }
    )
  }


  // 
  // 
  // 
  const handleOpenAlbum = (albumId, albumName) => {

    const albumData = {
      albumInfo: {
        currentAlbumId: albumId,
        currentAlbumName: albumName
      }
    }
    sessionStorage.setItem('albumInfo', JSON.stringify(albumData.albumInfo));

    history(BASE_URL +"/album");
  }

  useEffect(()=>{
    console.log(`toggleRemoveImageFromAlbumModal: ${toggleRemoveImageFromAlbumModal}`)
    console.log(`answerRemoveImageFromAlbumModal: ${answerRemoveImageFromAlbumModal}`)
  },[toggleRemoveImageFromAlbumModal])


  

  // 
  // RETURN ==============================================================================
  // 
  return (
    
    <Wrapper id="dashboard--wrapper">
      <Container id="dashboard--container">

        <Header id="dashboard--header" >
          
          {showDeletedImages ? 
            <>
              {/* <span className="strong">These are the picture you deleted form your <div>PictureViewer</div> store.</span> */}
              <span className="strong">Here is where you'll find the picture you temporarily delete form your <div>PictureViewer</div> store.</span>
              {/* <span className="under">You can either recover or permanently delete them</span> */}
            </>
          :
            <>

              <span className="strong">Are you ready to improve your fantastic <div>PictureViewer</div> store?</span>
            
            
              <div className='albums'>
                {
                  !albums 
                ? 
                  <div className='no-album'>

                    <span className="minor">It looks like you haven't created any picture album yet.</span>
                    {/* <span className='createAbum' onClick={()=>handleCreateAlbum('new album')}> */}
                    <span 
                      className='createAbum' 
                      onClick={()=>setToggleModal(true)} 
                    >
                      <div className='icon'><CreateNewFolderIcon sx={{ fontSize: 80 }} /></div>
                      <div className='text'></div>
                    </span>

                  </div>
                :
                  albums.map((album, albumIndex) =>

                    <div >
                    
                      {/* <Album 
                        handleOpenAlbum={()=>handleOpenAlbum(album.id, album.album_name)} 
                        album={album} albumIndex={albumIndex}
                      /> */}

                      { album &&
                        <Album 
                          album_id={album.id} 
                          album_name={album.album_name}
                          handleOpenAlbum={()=>handleOpenAlbum(album.id, album.album_name)} 
                          albumData={
                            assoc && assoc.filter((a, aIndex) => 
                              album.id === a.album_id && a  
                            )
                          } 
                          albumIndex={albumIndex}
                          setToggleDeleteAlbumModal={setToggleDeleteAlbumModal}
                          setDeleteAlbumDataModal={setDeleteAlbumDataModal}
                        />
                      }

                  </div>

                  )
                }
              </div> 
            </>
          }
          
        </Header>

        {/* <Content className="dashboard--content">
          <span>Or do you want to start by uploading some terrific picture?</span>
        </Content> */}

        <PictureContainer
          showDeletedImages={showDeletedImages} 
          setToggleMessageModal={setToggleMessageModal} 
          setMessage={setMessage} 
          setErrorMessage={setErrorMessage} 
          handleImageModalExpand={handleImageModalExpand}
          albums={albums}
          setMessageTitle={setMessageTitle}
          associatedAlbumId={associatedAlbumId}
          setAssociatedAlbumId={setAssociatedAlbumId}
          setDessociatedAlbumId={setDessociatedAlbumId}
          assoc={assoc}
          setToggleRemoveImageFromAlbumModal={setToggleRemoveImageFromAlbumModal}
          setRemoveImageFromAlbumDataModal={setRemoveImageFromAlbumDataModal}
          removeImageFromAlbumDataModal={removeImageFromAlbumDataModal}
          answerRemoveImageFromAlbumModal={answerRemoveImageFromAlbumModal}
          setAnswerRemoveImageFromAlbumModal={setAnswerRemoveImageFromAlbumModal}
          inAlbumOnly={inAlbumOnly}
          setToggleDeleteImageModal={setToggleDeleteImageModal}
          deleteImageDataModal={deleteImageDataModal}
          setDeleteImageDataModal={setDeleteImageDataModal}
          answerDeleteImageModal={answerDeleteImageModal}
          setAnswerDeleteImageModal={setAnswerDeleteImageModal}
        />
        
        
        {/* create new album */}
        {toggleModal && <Modal closeModal={setToggleModal} handleCreateAlbum={handleCreateAlbum} createAlbumMessage={createAlbumMessage}  />}

        {/* delete album */}
        {toggleDeleteAlbumModal && <DeleteAlbumModal deleteAlbumDataModal={deleteAlbumDataModal} closeModal={setToggleDeleteAlbumModal} handleDeleteAlbum={handleDeleteAlbum} deleteAlbumResult={deleteAlbumResult} deleteAlbumMessage={deleteAlbumMessage} deleteAlbumMessageError={deleteAlbumMessageError}  />}

        {/* remove image from  album */}
        {toggleRemoveImageFromAlbumModal && <RemoveImageFromAlbumModal removeImageFromAlbumDataModal={removeImageFromAlbumDataModal} closeModal={setToggleRemoveImageFromAlbumModal} setAnswerRemoveImageFromAlbumModal={setAnswerRemoveImageFromAlbumModal}  />}

        {/* delete image from  roll */}
        {
          toggleDeleteImageModal && <DeleteImageModal 
            closeModal={setToggleDeleteImageModal}
            deleteImageDataModal={deleteImageDataModal}
            setAnswerDeleteImageModal={setAnswerDeleteImageModal} 

          />
        }

        {/* MessageModal */}
        {toggleMessageModal && <MessageModal closeModal={setToggleMessageModal} title={messageTitle} message={message} errorMessage={errorMessage}/>}
        
      </Container>
    </Wrapper>
    
  )
}

export default Dashboard;

const Wrapper = styled.div `
  width: 100%;
  /* height: 90vh; */
  min-height: 90vh;
  color: #d1d1d1;
  background-color: transparent;
  font-size:2rem;
  /* padding: 10px 30px; */

  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
`;

const Container = styled.div `
  min-width: 80vw;
  max-width: 90%;
  border: 1px solid orange;
  /* margin-top: 60px; */
  max-width: 100%;
  /* padding: 30px 50px; */
  background-color: rgba(0,0,0,0.4);
`;

const Header = styled.div `
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;

  span.strong {
    font-size: 1.8rem;
    font-weight: 600;
    text-align: center;

    div {
      color: orange
    }

    @media screen AND (max-width: 575px) {
      font-size: 1.4rem;
    }
    @media screen AND (max-width: 375px) {
      font-size: 1rem;
    }
  }

  span.under {
    font-size: 1.6rem;
    font-weight: 400;
    text-align: center;

    div {
      color: orange
    }

    @media screen AND (max-width: 575px) {
      font-size: 1.3rem;
    }
    @media screen AND (max-width: 375px) {
      font-size: .9rem;
    }
  }

  span.minor {
    margin-top: 30px;
    font-size: 1.2rem;
    font-weight: 400;
    text-align: center;

    @media screen AND (max-width: 575px) {
      font-size: 1rem;
    }
    @media screen AND (max-width: 375px) {
      font-size: .8rem;
    }
  }

  span.createAbum {
    display: flex;
    justify-content: center;
    align-items: center;
    
    cursor: pointer;
    width: 100px;
    height: 60px;
    /* border: 1px solid orange; */
    font-size: 1.4rem;
    margin-top: 1rem;
    margin-right: 2rem;
    text-decoration: underline;
    position: relative;

    .icon {
        position: absolute;
      }
    .text {
      position: absolute;

      color: orange;
      font-weight: 700;
      /* background-color: rgba(0,0,0,.6); */
      width: 100%;
      height: 100%;

      display: flex;
      justify-content: center;
      align-items: center;
    }

    
  }

  div.albums {
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;

    margin-top: 3rem;

    div.no-album {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 2rem;
    }
    
    div.album {
      display: flex;
      justify-content: center;
      align-items: center;

      color: transparent;
      position: relative;
      width: 200px;
      height: 160px;
      border: 1px solid orange;
      font-size: 1.4rem;
      /* margin-right: 2rem; */
      text-decoration: underline;
      cursor: pointer;
        overflow: hidden;

      .icon {
        position: absolute;

        color: #d1d1d1;

        img {
          width: 200px; 
          height: 160px; 
          /* width: 100%;
          height: 100%; */
        }
      }
      .textContainer {
        position: absolute;

        color: orange;
        font-weight: 700;
        /* background-color: rgba(0, 0, 0, .6); */
        width: 100%;
        height: 100%;

        display: flex;
        /* flex-direction: column; */
        justify-content: center;
        align-items: center;
        
        .screen-one, .screen-two {
          position: absolute;
          width: 100%;
          height: 100%;
          /* border: 1px solid red; */
        }
        .screen-one {
          background-color: rgba(0, 0, 0, .1);
        }
        .screen-two {
          background-color: rgba(0, 0, 0, .1);
        }

        .images-count {
          /* font-family: 'Londrina Outline', cursive; */

          position: absolute;
          font-size: 6rem;
          text-align: center;
          color: rgba(255, 165, 0, .6);
          /* color: rgba(185, 185, 185, .6); */
        }

        .text {
          position: absolute;
        }
      }
      .iconsContainer {
        position: absolute;

        top: 0;
        left: 0;
        width: 22px;
        height: 24px;
        /* background-color: rgba(255, 255, 25, .6); */
        color: inherit;
        transition: all .7s ease-in-out;
      }
      &:hover {
        color: #d1d1d1;
        /* background-color: rgba(255, 255, 25, .6); */
      }
    }
  }
`;

const Content = styled.div `

  display: flex;
  /* flex-direction: row; */
  justify-content: center;
  align-items: center;

  margin-top: 2.8rem;

  .image-container {
    width: 200px;
    height: 130px;
    margin: 20px 10px;
    border: 1px solid orange;
    overflow: hidden;

    &:last-child {
      margin-right: 0;
    }

    img {
      width: 100%;
    }
  }

  span {
    font-size: 1.4rem;
    font-weight: 700;
  }

`;

const Button = styled.button `
  color: #fff;
  border: 1px solid #1b1b1b;
  background-color: #029F85;
  border-radius: 5px;;
  font-size: 1rem;
  padding: 1rem .8rem;
  margin-top: .4rem;
  width: 200px;

  cursor: pointer;
`;

const Features = styled.div `
  width: 100%;
  font-size: 1.4rem;
  font-weight: 700;

  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  /* align-items: center; */

  p {
    margin-top: 20px;
    font-size: 1rem;
    font-weight: 100;

    display: flex;
    flex-direction: column;

    .icon-container {
      margin-right: 30px;

      display: flex;
      gap: 10px;

      div {
        font-weight: 600;
        font-size: 1.2rem;
      }
    }

    div {
      font-weight: 100;

    }
  }

`;
